var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_vm._v("\n  test\n  "),_c('v-text-field',{attrs:{"label":_vm.label,"readonly":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }